<template>
	<div class="container">
		<div class="container_item">
			<slot></slot>
		</div>
	</div>
</template>
<script setup lang="ts"></script>

<style lang="scss" scoped>
.container {
	width: 100%;
	background: #212c3f;
	&_item {
		max-width: 68rem;
		width: 100%;
		margin: 0 auto;
		@media screen and (max-width: 1280px) {
			padding: 0rem 2rem;
		}
	}
}
</style>
